import { Controller } from '@hotwired/stimulus';
import CurrentPage from '@frontend/app/features/CurrentPage';

export default class extends Controller {
  connect() {
    if(CurrentPage.isDeepLinkingToComment()) {
      document.querySelector('#comments').scrollIntoView();
    }
  }
}
